<template>
  <div class="container">
    <div class="selection" v-if="data.length !== 0">
      <h4>{{ $t('admin.school.title') }}</h4>
      <a-button type="primary" @click="create">{{ $t('admin.school.createDict') }}</a-button>
    </div>
    <div v-if="data.length === 0" class="noData">
      <img src="@/assets/img/no_data_school.png" alt="">
      <span>{{ $t('admin.school.noDict') }}</span>
      <a-button type="primary" @click="create">{{ $t('admin.school.createDict') }}</a-button>
    </div>
    <div class="content" v-else>
      <a-tree :tree-data="data" :replaceFields="replaceFields">
        <template slot="custom" slot-scope="item">
          <div class="itemContent">
            <span>{{ item.name }}</span>
            <div class="operation">
              <span class="edit" @click="edit(item)">{{ $t('admin.school.edit') }}</span>
              <span class="remove" @click="delModal(item)">{{ $t('admin.school.delete') }}</span>
            </div>
          </div>
        </template>
      </a-tree>
    </div>
    <a-modal :title="$t('admin.school.dictManage')" :visible="editShow" @ok="submitEdit" @cancel="editShow = false">
      <a-form :form="formEdit">
        <a-form-item :label="$t('admin.school.dictType')">
          <a-select allowClear :disabled="!!id" v-decorator="['type', { rules: [{ required: true, message: $t('admin.school.selectType') }] }]" :placeholder="$t('admin.school.selectType')" @change="typeChange">
            <a-select-option v-for="item in typeList" :key="item.id" :value="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :label="$t('admin.school.parentDict')" v-if="formEdit.getFieldValue('type') > 1">
          <a-select allowClear v-decorator="['pid', { rules: [{ required: true, message: $t('admin.school.selectParent') }] }]" :placeholder="$t('admin.school.selectParent')">
            <a-select-option v-for="item in parentList" :key="item.id" :value="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :label="$t('admin.school.dictName')">
          <a-input allowClear :maxLength="15" v-decorator="['name', { rules: [{ required: true, message: $t('admin.school.inputName') }] }]" :placeholder="$t('admin.school.inputName')" />
        </a-form-item>
      </a-form>
    </a-modal>
    <TipModal @ok="del" :visible="delVisible" @cancel="delVisible = false" :desc="`<p>${$t('admin.school.deleteConfirm', { type: deleteTitle })}</p><p class='placeholder'>${deleteDesc}</p>`" />
  </div>
</template>

<script>
import { collegeDel, collegeList, collegeSave } from '@/api/admin'
import TipModal from '@/components/tipModal/index.vue'

export default {
  components: {
    TipModal
  },
  data() {
    return {
      delId: undefined,
      delVisible: false,
      editShow: false,
      id: null,
      replaceFields: {
        key: 'id',
        value: 'id',
        title: 'name',
        children: 'child'
      },
      data: [],
      typeList: [
        { 
          id: 1, 
          name: this.$t('admin.school.college'), 
          desc: this.$t('admin.school.deleteCollegeDesc') 
        },
        { 
          id: 2, 
          name: this.$t('admin.school.department'), 
          desc: this.$t('admin.school.deleteDeptDesc') 
        },
        { 
          id: 3, 
          name: this.$t('admin.school.major'), 
          desc: this.$t('admin.school.deleteMajorDesc') 
        }
      ],
      deleteTitle: '',
      deleteDesc: '',
      parentList: [],
      formEdit: this.$form.createForm(this)
    }
  },
  methods: {
    create() {
      this.id = null
      this.editShow = true
      this.formEdit.resetFields()
    },
    edit(record) {
      console.log(record)
      this.id = record.id
      this.editShow = true
      this.editId = record.id
      this.typeChange(record.scopedSlots.level)
      this.$nextTick(() => {
        this.formEdit.setFieldsValue({
          name: record.name,
          type: record.scopedSlots.level
        })
        this.$nextTick(() => {
          this.formEdit.setFieldsValue({
            pid: record.scopedSlots.parentId
          })
        })
      })
    },
    typeChange(value) {
      // 递归data，找到对应的所有父级
      const recursion = (data, level) => {
        data.forEach(element => {
          if (level === (value - 1)) {
            this.parentList.push(element)
          } else {
            recursion(element.child, level + 1)
          }
        })
      }
      this.formEdit.setFieldsValue({
        pid: undefined
      })
      this.parentList = []
      recursion(this.data, 1)
    },
    delModal(data) {
      this.delId = data.id
      this.deleteTitle = this.typeList[data.scopedSlots.level - 1].name
      this.deleteDesc = this.typeList[data.scopedSlots.level - 1].desc
      this.delVisible = true
    },
    async del() {
      const res = await collegeDel({ id: this.delId })
      if (res.code === 200) {
        this.delVisible = false
        this.getCollegeList()
        this.$message.success(this.$t('admin.school.deleteSuccess'))
      }
    },
    submitEdit() {
      this.formEdit.validateFields(async (err, values) => {
        if (!err) {
          const res = await collegeSave({ ...values, id: this.id })
          if (res.code === 200) {
            this.editShow = false
            this.getCollegeList()
            this.$message.success(this.$t('admin.school.saveSuccess'))
          }
        }
      })
    },
    async getCollegeList() {
      const data = {}
      const res = await collegeList(data)
      if (res.code === 200) {
        this.data = res.data.list
        this.append(this.data, 1)
      }
    },
    // 数据添加自定义项
    append(data, level, parentId) {
      data.forEach(item => {
        if (item.child.length !== 0) {
          this.append(item.child, level + 1, item.id)
        }
        item.scopedSlots = { title: 'custom', level, parentId: parentId }
      })
    }
  },
  mounted() {
    this.getCollegeList()
  }
}
</script>

<style lang="less" scoped>
.container {
  position: relative;
  /deep/ .ant-table {
    min-height: 583px;
  }
  .list-pagination {
    position: absolute;
    // bottom: 50px;
    width: calc(100% - 44px);
  }
}
h4 {
  font-size: 16px;
  font-weight: 800;
  color: #000000;
  line-height: 22px;
}
.content {
  width: 100%;
  padding: 20px 100px 20px 20px;
  border: 1px solid #e8e8e8;
  height: calc(100% - 100px);
  overflow: scroll;
}
.itemContent{
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px;
  .operation {
    display: none;
    justify-content: space-between;
    width: 100px;
  }
  &:hover {
    .operation {
      display: flex;
    }
  }
}
/deep/ .ant-tree li{
  .ant-tree-node-content-wrapper {
    height: auto;
  }
  span.ant-tree-switcher{
    line-height: 31px;
  }
}
.edit,
.remove {
  margin-left: 10px;
  cursor: pointer;
  color: #333;
}
/deep/ .ant-tree li .ant-tree-node-content-wrapper{
  width: 100%;
}
.admin {
  width: 100%;
  cursor: pointer;
  text-align: right;
  margin-bottom: 21px;
  .user-logo {
    width: 26px;
    height: 26px;
    border-radius: 100%;
    margin-right: 12px;
  }
  .down {
    width: 10px;
    margin-left: 5px;
  }
}
.selection {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 22px;
  justify-content: space-between;
  /deep/.ant-input,
  /deep/.ant-input-affix-wrapper {
    width: 237px;
    height: 35px;
    color: #000;
    margin-right: 30px;
    border-radius: 20px;
    .ant-input-prefix,
    .ant-input-suffix {
      > img {
        width: 16px;
        cursor: pointer;
      }
    }
    .ant-input-suffix .clear {
      width: 14px;
      height: 14px;
    }
  }
}
.noData{
  display: flex;
  align-items: center;
  padding-bottom: 70px;
  flex-direction: column;
  justify-content: center;
  flex-direction: lab;
  height: calc(100% - 120px);
  img{
    width: 285px;
    margin-bottom: 12px;
  }
  > span{
    font-size: 14px;
    color: #0D2340;
    margin-top: -40px;
  }
  button{
    margin-top: 20px;
  }
}
/deep/.ant-input-suffix {
  right: 12px;
  img {
    width: 23px;
    cursor: pointer;
  }
}
/deep/.ant-form {
  .ant-form-item {
    margin-bottom: 22px;
    .ant-form-item-label {
      margin-bottom: 6px;
      line-height: normal !important;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
}
/deep/ .ant-btn.ant-btn-primary {
  width: auto;
}
.placeholder {
  font-size: 14px;
  font-weight: 400;
  color: #596777;
  line-height: 20px;
  margin-top: 12px;
}
</style>
